angular.module("providers")

    .controller("ProvidersEditCtrl", ['LoginService', '$state', '$rootScope', '$stateParams', '$scope', 'Restangular', 'modalService', '$filter', '$translate',
        function (LoginService, $state, $rootScope,$stateParams, $scope, Restangular,modalService, $filter, $translate) {
            $scope.allowWrite = LoginService.permissionExist("PROVIDERS_WRITE");


            if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

                $rootScope.breadcrumb = [
                    { title: $filter('translate')('providers.title'), url: "providers.list" },
                    { title: $filter('translate')('providers.button_add') }
                ];
                $scope.warehouses = {};

            } else {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('providers.title'), url: "providers.list" },
                    { title: $filter('translate')('providers.button_edit'), url: "providers.edit({ id: " + $stateParams.id + " })" },
                ];

                Restangular.one('Providers', $stateParams.id).get().then(function (results) {
                    $scope.providers = results;
                });

            };


            $scope.save = function (frmProviders) {

                if (!angular.isUndefined($scope.providers.id)) {
                    $scope.providers.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('providers.edit_success'));
                            if ($scope.callbackFn != null) {
                                $scope.callbackFn(result);
                            } else {
                                $state.go("providers.list");
                            }
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                } else {
                    Restangular.all('Providers').post($scope.providers).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('providers.create_success'));
                            if ($scope.callbackFn != null) {
                                $scope.callbackFn(result);
                            } else {
                                $state.go("providers.list", { id: result.id, is_template: false });
                            }
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                }
            }

            $scope.onCancel = function () {
                if ($scope.callbackFn != null) {
                    $scope.callbackFn(null);
                } else {
                    $state.go("providers.list");
                }
            };

            $scope.checkDelete = function () {
                modalService.confirm({
                    title: $filter('translate')('providers.button_delete'),
                    message: $filter('translate')('providers.delete_message') + " " + $scope.providers.name + "?",
                    onAccept: function () {
                        $scope.providers.remove().then(function () {
                            toastr.success($filter('translate')('providers.delete_success'));
                            $state.go("providers.list");
                        });
                    }
                });
            };


        }]);